import { Component, Mixins, Vue } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";
import { ScoutingFilter } from "@/models/Scouting";
import RequestsMixin from "@/mixins/http/RequestsMixin";

const GET_POLYGON_POPULATION = "get_polygon_population";
const GET_MEDIA_COVERAGE = "get_media_coverage";
const GET_ANALYSIS = "get_analysis";
export const LIST_ANALYSES = "list_analyses";
const CREATE_ANALYSIS = "create_analysis";
const GET_LOCATION_COUNTERS = "get_location_counters";
const DELETE_ANALYSIS = "delete_analysis";

@Component
export default class AnalysisMixin extends Mixins(RequestsMixin) {
  readonly reportPath = BASE_API_URL + "current_user/scouting";
  readonly analysisPath = BASE_API_URL + "scoutings/analyses";
  readonly indexPath = BASE_API_URL + "medium_coverages";

  getAnalysis(id: string) {
    const routes = this.$getModelRoutes("scoutings/analyses");
    const path = routes.getUrl(id, {
      include:
        "*,company,scouting_media,scouting_media.medium,scouting_media.medium.medium_type,scouting_places.isocron",
    });
    return this.$httpGet(path, GET_ANALYSIS);
  }

  getMediumCoverages(filters: any) {
    return this.$httpPost(
      this.reportPath + "/medium_coverages",
      GET_MEDIA_COVERAGE,
      filters
    );
  }

  getSourceableMediumCoverages(sourceableType: string, sourceableId: string) {
    const routes = this.$getModelRoutes("medium_coverages");
    return this.$httpGet(
      routes.indexUrl({
        sourceable_type: sourceableType,
        sourceable_id: sourceableId,
        include: "*,medium,medium.medium_type",
      }),
      GET_MEDIA_COVERAGE
    );
  }

  getPolygonPopulations(filters: any) {
    return this.$httpPost(
      this.reportPath + "/populations",
      GET_POLYGON_POPULATION,
      filters
    );
  }

  listAnalyses(filters: ScoutingFilter) {
    const path = `${BASE_API_URL}scoutings/analyses${filters.toParams()}`;
    return this.$httpGet(path, LIST_ANALYSES);
  }

  createAnalysis(parameters: any) {
    return this.$httpPost(
      BASE_API_URL + "scoutings/analyses",
      CREATE_ANALYSIS,
      parameters
    );
  }

  deleteAnalysis(id: string) {
    return this.$httpDelete(
      BASE_API_URL + "scoutings/analyses/" + id,
      DELETE_ANALYSIS
    );
  }

  getLocationCounters() {
    return this.$httpGet(
      BASE_API_URL + "utils/location_counters",
      GET_LOCATION_COUNTERS
    );
  }
}
